const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hours: 'numeric', minutes: 'numeric', seconds: 'numeric'};

export const localDate = (date) => {
    return `${new Date(date).toLocaleString('Es-es', options)}`;
};

export const localDateAndTime = (date) => {
    return `${new Date(date).toLocaleString().split(',')[0]} ${new Date(date).toLocaleString().split(',')[1].split(':').slice(0,2).join(':')} hs.`;
};